export default {"src":"/_next/static/media/card_bg_communaute.7f34038b.svg","height":435,"width":1031};